<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $tc("privateRateCardGroup") }}</div>
    </div>
    <div class="white-wrapper">
      <section class="row pvt-rate-card">
        <div class="col-12">
          <div class="align-items-center row mb-4">
            <div class="col-lg-4 col-xl-4 align-self-center mb-4">
              <div class="dropdown-curve-container mr-2">
                <label :class="selectedCinema && selectedCinema.length > 0
                  ? 'shift-up'
                  : ''
                  ">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
                <b-dropdown :disabled="isRoleID" :text="selectedCinema" name="selectcinema" id="selectcinema"
                  variant="dropdown-curve" class="w-100">
                  <div class="px-2 pb-2">
                    <input required autofocus type="search" placeholder="Search Cinema"
                      class="form-control form-control-sm" v-on:keyup="onSearchCinema($event.target.value)"
                      v-on:keydown="onSearchCinema($event.target.value)" v-on:search="onSearchCinema($event.target.value)"
                      v-model="searchCinema" />
                  </div>
                  <b-dropdown-item href="#" v-for="(Cinema, CinemaIndex) in Cinemas" :key="CinemaIndex"
                    v-on:click="onSelectCinema($event, Cinema)">{{ Cinema.cine_name }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div class="col-lg-6 col-xl-4 align-self-center mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input placeholder="." v-model="privateRateCard.rate_card_name" type="text" name="cardname"
                    id="cardname" v-validate="'required'" />
                  <label>{{ $t("ratecard") }} {{ $t("name") }}</label>
                </div>
                <!-- <Tooltip :title="'Rate Card Group Name'" /> -->
              </div>
              <p v-if="submitted && errors.has('cardname')" class="error_message">
                {{ errors.first("cardname") }}
              </p>
            </div>
            <div class="col-lg-6 col-xl-4 align-self-center mb-4">
              <div class="d-flex align-items-center">
                <label class="mb-0 mr-3">is Private Screening</label>
                <b-form-checkbox :disabled="isEdit" v-model="privateRateCard.isPrivateScreening" name="check-button"
                  switch class="j-checkbox mb-0 ml-2" @change="resetHandler($event)"></b-form-checkbox>
              </div>
            </div>
            <div class="col-lg-6 col-xl-4 align-self-center mb-4" v-if="privateRateCard.isPrivateScreening">
              <div class="d-flex align-items-center">
                <label class="mb-0 mr-3">Add Ons Compulsory</label>
                <b-form-checkbox v-model="privateRateCard.isFnbCompulsory" name="check-button" switch
                  class="j-checkbox mb-0 ml-2"></b-form-checkbox>
              </div>
            </div>
            <div class="col-lg-6 col-xl-4 align-self-center mb-4" v-if="!privateRateCard.isPrivateScreening">
              <div class="d-flex align-items-center">
                <label class="mb-0 mr-3">Add Ons Compulsory</label>
                <b-form-checkbox v-model="isFnbCompulsoryForNormalRateCard" name="check-button" switch
                  class="j-checkbox mb-0 ml-2" @change="onChangeAddOnsCumpulsoryBtn($event)"></b-form-checkbox>
              </div>
            </div>
            <div class="col-lg-6 col-xl-4 align-self-center mb-4">
              <div class="d-flex align-items-center">
                <label class="mb-0 mr-3">Active</label>
                <b-form-checkbox unchecked-value="N" value="Y" v-model="privateRateCard.rc_g_is_active"
                  name="check-button" switch class="j-checkbox mb-0 ml-2"></b-form-checkbox>
              </div>
            </div>
          </div>
          <!-- <div class="float-right mr-3">
            <h3 class="text-right text-dark">INR 1000</h3>
          </div> -->

          <!-- Ticket Section -->
          <section class="mb-4">
            <div class="section-title mb-3 d-flex justify-content-between section-collapse-box" v-b-toggle.collapseTicket>
              <div>
                <h3 class="mb-2 d-inline-block">Ticket</h3>
                <!-- <span class="font-weight-normal"
                  >- Regular, 7.7 VAT, INR 180</span
                > -->
              </div>
              <button type="button" class="btn-transparent chevron">
                <img src="@/assets/img/icons/primary/chevron-down.svg" height="24" width="24" />
              </button>
            </div>

            <b-collapse visible id="collapseTicket">
              <div class="row">
                <section class="col-12">
                  <article class="mb-5 row px-4" v-for="(
                      rateCard, rateCardIndex
                    ) in privateRateCard.ratecards" :key="rateCardIndex">
                    <div class="col-md-11 pvt-rate-card-box">
                      <div class="d-flex align-items-center mb-3" v-if="privateRateCard.isPrivateScreening">
                        <label class="mb-0 mr-3">{{
                          $t("blockPricing")
                        }}</label>
                        <b-form-checkbox unchecked-value="N" value="Y" v-model="rateCard.is_ticket_slab"
                          name="check-button" switch class="j-checkbox mb-0 ml-2"
                          @change="onChangeTicketSlab"></b-form-checkbox>
                        <!-- <Tooltip
                          :title="$t('blockPricingTooltip')"
                          class="ml-3"
                        /> -->
                      </div>

                      <section class="">
                        <article>
                          <p>Ticket Type</p>
                          <p>
                            <b-dropdown :text="rateCard.selectedTicketType ||
                              'Select Ticket type'
                              " variant="dropdown-curve" class="movie-dropdown" :disabled="privateRateCard.isPrivateScreening &&
    rateCardIndex != 0
    ">
                              <b-dropdown-item v-for="(ticketType, ttIndex) in NewTicketTypes" :key="ttIndex" v-on:click="
                                onSelectTicketType(
                                  $event,
                                  ticketType,
                                  rateCardIndex
                                )
                                ">{{ ticketType.tt_name }}
                              </b-dropdown-item>
                            </b-dropdown>
                          </p>
                        </article>
                        <article>
                          <p>Charge Setting</p>
                          <p>
                            <b-dropdown :text="rateCard.selected_charge_setting ||
                              'Charge Settings'
                              " variant="dropdown-curve" class="movie-dropdown" v-on:show="checkCinema" :disabled="rateCard.hasOwnProperty('rc_id') && isEdit
    ">
                              <b-dropdown-item v-for="(charge, chargeIndex) in chargeSettings" :key="chargeIndex"
                                v-on:click="
                                  onSelectChargeSetting(
                                    $event,
                                    charge,
                                    rateCardIndex
                                  )
                                  ">{{
    charge.pas_charge_setting_name
  }}
                              </b-dropdown-item>
                            </b-dropdown>
                          </p>
                        </article>
                        <article>
                          <p>Rate per ticket</p>
                          <p>
                            <input v-model="rateCard.price" type="text" name="price" id="price" v-validate="'required'"
                              placeholder="Rate per ticket" class="form-control" @change="handleRateChange(rateCardIndex)"
                              @blur="handleRateChange(rateCardIndex)" />
                          </p>
                        </article>
                        <article>
                          <p>No. of Seats</p>
                          <p>
                            <input v-model="rateCard.quantity" @change="onChangeQuantity($event, rateCardIndex)"
                              type="number" :min="0" name="quantity" id="quantity" v-validate="'required'"
                              placeholder="No. of Seats" class="form-control" :class="!privateRateCard.isPrivateScreening
                                ? 'qtdisable'
                                : ''
                                " :disabled="!privateRateCard.isPrivateScreening" />
                          </p>
                        </article>
                        <article>
                          <p>Gross Price</p>
                          <p>
                            <input v-model="rateCard.total_price" @change="cinemaChargesCalculation(rateCardIndex)"
                              type="number" :min="0" name="gross_with_exclusive" id="gross_with_exclusive"
                              placeholder="Gross Price" class="form-control" />
                          </p>
                        </article>

                        <article>
                          <p>Net Price</p>
                          <p>
                            <input v-model="rateCard.net_price" @change="cinemaChargesCalculation(rateCardIndex)"
                              type="number" :min="0" name="quantity" id="quantity" v-validate="'required'"
                              placeholder="Net Price" class="form-control" />
                          </p>
                        </article>
                        <article v-for="(tax, taxIndex) in rateCard.tax" :key="taxIndex">
                          <p>
                            {{ tax.charge_name }} {{ tax.charge_value }}
                            {{ tax.pas_is_percentage == "Y" ? "%" : "" }}
                          </p>
                          <p>
                            <input v-model="tax.cinemacharges" type="number" :min="0" :name="'tax' + taxIndex"
                              :id="'tax' + taxIndex" v-validate="'required'" :placeholder="tax.charge_name"
                              class="form-control" />
                          </p>
                        </article>
                        <article v-if="!privateRateCard.isPrivateScreening">
                          <p>
                            {{ $t("online_fee") }}
                          </p>
                          <p>
                            <input v-model="rateCard.internet_fee" type="number" :min="0" name="internet_fee"
                              id="internet_fee" v-validate="'required'" :placeholder="$t('online_fee')"
                              class="form-control" />
                          </p>
                        </article>
                        <template v-if="showErpColumns">
                          <article>
                            <p>
                              {{ $t("report_code") }}
                            </p>
                            <p>
                              <input id="report_code" v-model="rateCard.report_code" placeholder="Report Code"
                                class="form-control" name="report_code" type="text" />
                            </p>
                          </article>
                          <article>
                            <p>
                              {{ $t("gl_account") }}
                            </p>
                            <p>
                              <input id="gl_account" v-model="rateCard.gl_account" placeholder="GL Account"
                                class="form-control" name="gl_account" type="text" />
                            </p>
                          </article>
                          <article>
                            <p>
                              {{ $t("gl_desc") }}
                            </p>
                            <p>
                              <input id="gl_desc" v-model="rateCard.gl_desc" placeholder="GL Description"
                                class="form-control" name="gl_desc" type="text" />
                            </p>
                          </article>
                        </template>

                        <div class="cd-flex align-items-center align-self-center mt-4">
                          <div class="d-flex align-items-center">
                            <label class="mb-0 mr-3">Default Rate Card</label>
                            <b-form-checkbox unchecked-value="N" value="Y" v-model="rateCard.default_rate_card"
                              name="check-button" switch class="j-checkbox mb-0 ml-2" @change="
                                OnchangeDefaultRateCard($event, rateCardIndex)
                                "></b-form-checkbox>
                          </div>
                        </div>
                        <div class="d-flex align-items-center mt-4" v-if="!privateRateCard.isPrivateScreening && false"
                          v-b-tooltip.hover.top="'Tooltip content'">
                          <span>is Add Ons Compulsory</span>
                          <b-form-checkbox v-model="rateCard.isFnbCompulsory" type="checkbox"
                            class="j-checkbox mb-0 ml-2" />
                          <!-- <Tooltip
                            :title="'If Ticket slab is active, then you will need to purchase slabs of tickets and not individual tickets'"
                          /> -->
                        </div>
                      </section>
                      <p class="total-price mt-4">
                        <span>Total</span>
                        <span>{{ currencyData.curr_code }} &nbsp;
                          {{
                            (
                              parseFloat(rateCard.total_price) *
                              (parseInt(rateCard.quantity) || 0) +
                              (parseFloat(rateCard.internet_fee) || 0)
                            ).toFixed(3)
                          }}</span>
                      </p>

                      <div class="fnb-section mt-3" v-if="rateCard.isFnbCompulsory &&
                          !privateRateCard.isPrivateScreening &&
                          false
                          ">
                        <article class="pvt-rate-card-box">
                          <div class="section-title">Add Ons</div>
                          <hr />

                          <section class="" v-for="(
                              fnbcharge, fnbchargeIndex
                            ) in rateCard.fnbCharges" :key="fnbchargeIndex">
                            <article>
                              <p>Item</p>
                              <p>
                                <b-dropdown :text="fnbcharge.item_name || 'Item'" variant="dropdown-curve"
                                  class="movie-dropdown">
                                  <div class="px-2 pb-2">
                                    <input required autofocus type="search" placeholder="Search Item"
                                      class="form-control form-control-sm" v-on:keyup="
                                        onSearchFnb($event.target.value)
                                        " v-on:keydown="
    onSearchFnb($event.target.value)
    " v-on:search="
    onSearchFnb($event.target.value)
    " v-model="searchItem" />
                                  </div>
                                  <b-dropdown-item v-for="(fnb, fnbIndex) in fnbItems" :key="fnbIndex" href="#" @click="
                                    onSelectFnbItem(
                                      $event,
                                      fnb,
                                      rateCardIndex,
                                      fnbchargeIndex
                                    )
                                    ">{{ fnb.item_name }}
                                  </b-dropdown-item>
                                </b-dropdown>
                              </p>
                            </article>
                            <article>
                              <p>Cost Price</p>
                              <p>
                                <input v-model="fnbcharge.cost_price" type="number" :min="0" name="fnbcostprice"
                                  id="fnbcostprice" v-validate="'required'" placeholder="Cost Price"
                                  class="form-control" />
                              </p>
                            </article>
                            <article>
                              <p>Net Price</p>
                              <p>
                                <input v-model="fnbcharge.net_price" type="number" :min="0" name="fnbnetprice"
                                  id="fnbnetprice" v-validate="'required'" placeholder="Net Price" class="form-control" />
                              </p>
                            </article>
                            <article>
                              <p>Taxes</p>
                              <p>
                                <input v-model="fnbcharge.tax" type="number" :min="0" name="fnbtaxes" id="fnbtaxes"
                                  placeholder="FNB Taxes" class="form-control" />
                              </p>
                            </article>
                            <article>
                              <p>Original Sales Price</p>
                              <p>
                                <input v-model="fnbcharge.original_sales_price" type="number" :min="0"
                                  name="fnbsalesprice" id="fnbsalesprice" v-validate="'required'"
                                  placeholder="Original Sales Price" class="form-control" />
                              </p>
                            </article>
                          </section>
                        </article>
                      </div>
                    </div>
                    <div class="col-1 d-flex align-items-center justify-content-center border-left">
                      <button v-if="rateCardIndex !== 0 ||
                        privateRateCard.ratecards.length > 1
                        " @click.prevent.stop="
    removeRateCard($event, rateCardIndex)
    " class="btn-transparent">
                        <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
                      </button>
                    </div>
                  </article>
                  <div class="w-100 d-flex align-items-center justify-content-center border-top my-4 position-relative">
                    <button @click.prevent.stop="addRateCard($event)" class="btn-transparent add-more-button">
                      <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
                    </button>
                  </div>
                </section>
              </div>
            </b-collapse>
          </section>

          <!-- FnB Section -->
          <section class="mb-4" v-if="privateRateCard.isPrivateScreening">
            <div class="section-title mb-3 d-flex justify-content-between section-collapse-box" v-b-toggle.collapseFnb>
              <div>
                <h3 class="d-inline-block">Add Ons</h3>
                <!-- <span class="font-weight-normal">- Coke, 7.7 VAT, INR 200</span> -->
              </div>
              <button type="button" class="btn-transparent chevron">
                <img src="@/assets/img/icons/primary/chevron-down.svg" height="24" width="24" />
              </button>
            </div>

            <b-collapse :visible="isEdit && FnbRateCards.length > 0" id="collapseFnb">
              <div class="row">
                <section class="col-12">
                  <article class="mb-5 row px-4" v-for="(fnbcharge, fnbChargeIndex) in FnbRateCards"
                    :key="fnbChargeIndex">
                    <div class="col-md-11 pvt-rate-card-box">
                      <section class="">
                        <article>
                          <p>Item</p>
                          <p>
                            <b-dropdown :text="fnbcharge.item_name || 'Item'" variant="dropdown-curve"
                              class="movie-dropdown overFlow-ellipisis">
                              <div class="px-2 pb-2">
                                <input required autofocus type="search" placeholder="Search Item"
                                  class="form-control form-control-sm" v-on:keyup="onSearchFnb($event.target.value)"
                                  v-on:keydown="
                                    onSearchFnb($event.target.value)
                                    " v-on:search="onSearchFnb($event.target.value)" v-model="searchItem" />
                              </div>
                              <b-dropdown-item v-for="(fnb, fnbIndex) in fnbItems" :key="fnbIndex" href="#"
                                @click="handleFnbSelect(fnb, fnbChargeIndex)">{{ fnb.item_name }}
                              </b-dropdown-item>
                            </b-dropdown>
                          </p>
                        </article>
                        <article>
                          <p>Charge Setting</p>
                          <p>
                            <b-dropdown :text="fnbcharge.selected_charge_setting ||
                              'Charge Settings'
                              " variant="dropdown-curve" class="movie-dropdown" v-on:show="checkCinema" :disabled="fnbcharge.hasOwnProperty('fnb_private_id') &&
    isEdit
    ">
                              <b-dropdown-item v-for="(charge, chargeIndex) in chargeSettings" :key="chargeIndex"
                                v-on:click="
                                  handleFnbCharge(charge, fnbChargeIndex)
                                  ">{{
    charge.pas_charge_setting_name
  }}
                              </b-dropdown-item>
                            </b-dropdown>
                          </p>
                        </article>
                        <article>
                          <p>Rate</p>
                          <p>
                            <input v-model="fnbcharge.price" @change="handleFNBRateChange(fnbChargeIndex)" type="text"
                              name="fnbprice" id="fnbprice" v-validate="'required'" placeholder="Price"
                              class="form-control" :class="!fnbcharge.charge_setting_id ? 'qtdisable' : ''
                                " :disabled="!fnbcharge.charge_setting_id" />
                          </p>
                        </article>
                        <article v-if="!fnbcharge.is_single_fnb">
                          <p>Quantity</p>
                          <b-dropdown :text="fnbcharge.quantity || 'Please select Quantity'
                            " variant="dropdown-curve" class="movie-dropdown" :disabled="!fnbcharge.item_id">
                            <b-dropdown-item v-for="(qt, qtIndex) in QuantityArray" :key="qtIndex" @click="
                              handleQuantityDropDown(qt, fnbChargeIndex)
                              ">{{ qt.value }}
                            </b-dropdown-item>
                          </b-dropdown>
                        </article>
                        <article>
                          <p>Net Price</p>
                          <p>
                            <input v-model="fnbcharge.net_price" type="number" :min="0" name="fnbnetprice"
                              id="fnbnetprice" v-validate="'required'" placeholder="Net Price" class="form-control" />
                          </p>
                        </article>
                        <article v-for="(tax, taxIndex) in fnbcharge.tax" :key="taxIndex">
                          <p>
                            {{ tax.charge_name }} {{ tax.charge_value }}
                            {{ tax.pas_is_percentage == "Y" ? "%" : "" }}
                          </p>
                          <p>
                            <input v-model="tax.cinemacharges" type="number" :min="0" :name="'tax' + taxIndex"
                              :id="'tax' + taxIndex" v-validate="'required'" :placeholder="tax.charge_name"
                              class="form-control" />
                          </p>
                        </article>
                        <article>
                          <p>Cost Price</p>
                          <p>
                            <input v-model="fnbcharge.cost_price" type="number" :min="0" name="fnbcostprice"
                              id="fnbcostprice" v-validate="'required'" placeholder="Cost Price"
                              class="form-control qtdisable" disabled />
                          </p>
                        </article>
                        <article>
                          <p>Original Sales Price</p>
                          <p>
                            <input v-model="fnbcharge.original_sales_price" type="number" :min="0" name="fnbsalesprice"
                              id="fnbsalesprice" v-validate="'required'" placeholder="Original Sales Price"
                              class="form-control qtdisable" disabled />
                          </p>
                        </article>
                        <div class="col-lg-6 col-xl-4 align-self-center mt-3">
                          <div class="d-flex align-items-center">
                            <label class="mb-0 mr-3">Single Item</label>
                            <b-form-checkbox v-model="fnbcharge.is_single_fnb" name="check-button" switch
                              class="j-checkbox mb-0 ml-2"></b-form-checkbox>
                          </div>
                        </div>
                      </section>
                      <p class="total-price mt-4">
                        <span>Total</span>
                        <span>{{ currencyData.curr_code }} &nbsp;
                          {{
                            (
                              parseFloat(fnbcharge.price) *
                              (fnbcharge.is_single_fnb
                                ? 1
                                : parseInt(fnbcharge.quantity) || 0)
                            ).toFixed(3)
                          }}</span>
                      </p>
                    </div>
                    <div class="col-1 d-flex align-items-center justify-content-center border-left">
                      <button @click.prevent.stop="
                      removeFnbRateCard($event, fnbChargeIndex)
                        " class="btn-transparent">
                        <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
                      </button>
                    </div>
                  </article>
                  <div class="w-100 d-flex align-items-center justify-content-center border-top my-5 position-relative">
                    <button @click.prevent.stop="addFnbRateCard($event)" class="btn-transparent add-more-button">
                      <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
                    </button>
                  </div>
                </section>
              </div>
            </b-collapse>
          </section>

          <section class="mb-4" v-if="isFnbCompulsoryForNormalRateCard &&
            !privateRateCard.isPrivateScreening
            ">
            <div class="section-title mb-3 d-flex justify-content-between section-collapse-box" v-b-toggle.collapseFnb>
              <div>
                <h3 class="d-inline-block">Add Ons</h3>
                <!-- <span class="font-weight-normal">- Coke, 7.7 VAT, INR 200</span> -->
              </div>
              <button type="button" class="btn-transparent chevron">
                <img src="@/assets/img/icons/primary/chevron-down.svg" height="24" width="24" />
              </button>
            </div>

            <b-collapse :visible="isEdit && privateRateCard.ratecards[0].fnbCharges.length > 0
              " id="collapseFnb">
              <div class="row">
                <section class="col-12">
                  <article class="mb-5 row px-4" v-for="(fnbcharge, fnbChargeIndex) in privateRateCard
                        .ratecards[0].fnbCharges" :key="fnbChargeIndex">
                    <div class="col-md-11 pvt-rate-card-box">
                      <section class="">
                        <article>
                          <p>Item</p>
                          <p>
                            <b-dropdown :text="fnbcharge.item_name || 'Item'" variant="dropdown-curve"
                              class="movie-dropdown">
                              <div class="px-2 pb-2">
                                <input required autofocus type="search" placeholder="Search Item"
                                  class="form-control form-control-sm" v-on:keyup="onSearchFnb($event.target.value)"
                                  v-on:keydown="
                                    onSearchFnb($event.target.value)
                                    " v-on:search="onSearchFnb($event.target.value)" v-model="searchItem" />
                              </div>
                              <b-dropdown-item v-for="(fnb, fnbIndex) in fnbItems" :key="fnbIndex" href="#" @click="
                                onSelectFnbItem(
                                  $event,
                                  fnb,
                                  0,
                                  fnbChargeIndex
                                )
                                ">{{ fnb.item_name }}
                              </b-dropdown-item>
                            </b-dropdown>
                          </p>
                        </article>
                        <article>
                          <p>Cost Price</p>
                          <p>
                            <input v-model="fnbcharge.cost_price" type="number" :min="0" name="fnbcostprice"
                              id="fnbcostprice" v-validate="'required'" placeholder="Cost Price" class="form-control" />
                          </p>
                        </article>
                        <article>
                          <p>Net Price</p>
                          <p>
                            <input v-model="fnbcharge.net_price" type="number" :min="0" name="fnbnetprice"
                              id="fnbnetprice" v-validate="'required'" placeholder="Net Price" class="form-control" />
                          </p>
                        </article>
                        <article>
                          <p>Taxes</p>
                          <p>
                            <input v-model="fnbcharge.tax" type="number" :min="0" name="fnbtaxes" id="fnbtaxes"
                              placeholder="FNB Taxes" class="form-control" />
                          </p>
                        </article>
                        <article>
                          <p>Original Sales Price</p>
                          <p>
                            <input v-model="fnbcharge.original_sales_price" type="number" :min="0" name="fnbsalesprice"
                              id="fnbsalesprice" v-validate="'required'" placeholder="Original Sales Price"
                              class="form-control" />
                          </p>
                        </article>
                      </section>
                      <p class="total-price mt-4">
                        <span>Total</span>
                        <span>{{ currencyData.curr_code }} &nbsp;
                          {{
                            parseFloat(
                              fnbcharge.original_sales_price
                                ? fnbcharge.original_sales_price
                                : 0
                            ).toFixed(3)
                          }}</span>
                      </p>
                    </div>
                  </article>
                </section>
              </div>
            </b-collapse>
          </section>
        </div>
      </section>
      <section class="row">
        <div class="col-md-12 text-center mt-4">
          <article class="d-flex justify-content-center align-items-center">
            <button class="btn-blue mr-3" :disabled="submitted" @click.prevent.stop="handleSubmit()">
              {{ $t("save") }}
            </button>
            <b-button class="btn-outline-grey" variant="default" to="list-private-rate-card">
              {{ $t("cancel") }}
            </b-button>
          </article>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import { mapState, mapGetters, mapActions } from "vuex";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
  },
  data() {
    return {
      isFnbCompulsoryForNormalRateCard: false,
      isRoleID: true,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selectedCinema: "",
      cinema_id: null,
      Cinemas: [],
      isEdit: false,
      //sorting
      isSort: false,
      isAscending: false,
      columnName: "created_at",
      orderBy: "desc",

      //for search
      debounce: null,
      searchValue: "",
      searchKey: "rc_name",
      submitted: false,
      // Saif
      checked: "N",
      gridView: false,
      listView: true,
      CinemasCopy: [],
      TicketTypes: [],
      chargeSettings: [],
      fnbItems: [],
      fnbItemsCopy: [],
      searchCinema: "",
      fnbCompulsory: false,
      currencyData: {},
      privateRateCard: {
        rc_is_active_inclusivtax: 'N',
        cinema_id: null,
        rate_card_name: "",
        isPrivateScreening: false,
        rc_g_is_active: "Y",
        isFnbCompulsory: false,
        ratecards: [
          {
            is_ticket_slab: "N",
            tt_id: null,
            report_code: "",
            gl_account: "",
            gl_desc: "",
            selectedTicketType: "",
            charge_setting_id: null,
            selected_charge_setting: "",
            price: 0,
            quantity: 0,
            net_price: 0,
            total_price: 0,
            is_inclusive_tax: "N",
            tax: [],
            internet_fee: 0,
            total_amount: 0,
            isFnbCompulsory: false,
            fnbCharges: [
              {
                item_id: null,
                item_name: "",
                charge_setting_id: null,
                selected_charge_setting: "",
                price: 0,
                quantity: 0,
                net_price: 0,
                is_inclusive_tax: "Y",
                tax: 0,
                cost_price: 0,
                original_sales_price: 0,
                total_amount: 0,
              },
            ],
          },
        ],
      },
      FnbRateCards: [],
      _FnbRateCards: [
        {
          item_id: null,
          item_name: "",
          charge_setting_id: null,
          selected_charge_setting: "",
          is_inclusive_tax: "Y",
          price: 0,
          quantity: "",
          net_price: 0,
          tax: [],
          cost_price: 0,
          original_sales_price: 0,
          total_amount: 0,
          is_single_fnb: false,
        },
      ],

      removedRateCards: [],
      removedFnbRateCard: [],

      singleRateCard: {
        is_ticket_slab: "N",
        tt_id: null,
        report_code: "",
        gl_account: "",
        gl_desc: "",
        selectedTicketType: "",
        charge_setting_id: null,
        selected_charge_setting: "",
        price: 0,
        quantity: 0,
        net_price: 0,
        total_price: 0,
        tax: [],
        internet_fee: 0,
        total_amount: 0,
        isFnbCompulsory: false,
        fnbCharges: {
          item_id: null,
          item_name: "",
          charge_setting_id: null,
          price: 0,
          quantity: 0,
          net_price: 0,
          tax: 0,
          cost_price: 0,
          original_sales_price: 0,
          total_amount: 0,
        },
      },

      SingleextraCharge: {
        label: "",
        charge_setting_id: null,
        price: 0,
        net_price: 0,
        tax: 0,
      },
      FnbQuantityArray: [],
      searchItem: "",
      cinemaChargesList: [],
      cinemaChargesListOnGross: [],
      cinemaChargeListOnNet: [],
      cinemaChargesListCopy: [],
      fnbtaxChargesListCopy: [],
      fnbtaxChargesList: [],
      totalTaxPercentage: 0,
      totalFnbTaxPercentage: 0,
    };
  },
  computed: {
    showErpColumns() {
      return this.$store.getters.SHOW_ERP_GL_FIELDS == "Y" ? true : false;
    },
    NewTicketTypes() {
      let ttIds = this.privateRateCard.ratecards.map((x) => x.tt_id);
      let result = this.TicketTypes.filter((x) => !ttIds.includes(x.tt_id));
      console.log("result", result);
      return result;
    },
    FilteredQuantities() {
      let quantities = this.FnbRateCards.map((x) => x.quantity);
      const result = this.FnbQuantityArray.filter(
        (x) => !quantities.includes(x.value)
      );
      console.log("result", result);
      return result;
    },
    QuantityArray() {
      let TempArray = [];
      this.privateRateCard.ratecards.map((x, index) => {
        let obj = {
          id: index,
          value: String(x.quantity),
        };
        if (String(x.quantity) != "0") {
          TempArray.push(obj);
        }
      });
      return TempArray;
    },
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.cinema_manager_add_edit_disabled = roleid;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemaList(obj);
    this.getTicketTypeList();
    // this.getFnBItems();
    this.getCurrencyCode();
    this.resetHandler(false);
  },
  mounted() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onSelectCinema(null, CinemaObj);
    }

    // if (CLIENT_NAME.QFX == this.CLIENT_SETUP_NAME) {
    if (this.authorizeClient(CLIENT_NAMES_OBJ.qfx_tax_structure)) {
      console.log({
        "CLIENT_NAMES_OBJ": CLIENT_NAMES_OBJ,
        "this.CLIENT_SETUP_NAME": this.CLIENT_SETUP_NAME,
      });
      const { id } = this.$route.query;

      let params = {
        path: "/cinema-manager/private-rate-card-v2",
      };

      if (id) {
        params.query = this.$route.query;
      }

      this.$router.push(params);
    }

    if (
      this.authorizeClient(CLIENT_NAMES_OBJ.ROONGTA) ||
      window.location.host.includes('roongta')
    ) {
      console.log({
        'window.location.host': window.location.host,
        "CLIENT_NAMES_OBJ": CLIENT_NAMES_OBJ,
        "this.CLIENT_SETUP_NAME": this.CLIENT_SETUP_NAME,
      });
      const { id } = this.$route.query;

      let params = {
        path: "/cinema-manager/private-rate-card-with-gst-sc",
      };

      if (id) {
        params.query = this.$route.query;
      }

      this.$router.push(params);
    }
  },
  methods: {
    OnchangeDefaultRateCard(event, rateCardIndex) {
      console.log("event", event, rateCardIndex);
      this.privateRateCard.ratecards.map((z, index) => {
        if (index == rateCardIndex) {
          z["default_rate_card"] = event;
        } else {
          z["default_rate_card"] = "N";
        }
      });
      this.$forceUpdate();
      console.log(
        "this.privateRateCard.ratecards",
        this.privateRateCard.ratecards
      );
    },
    onChangeAddOnsCumpulsoryBtn(event) {
      console.log("event", event);
      this.privateRateCard.ratecards.forEach((x, index) => {
        x["isFnbCompulsory"] = event;
      });
    },
    onChangeTicketSlab(event) {
      console.log("event", event);
      this.privateRateCard.ratecards.forEach((x) => {
        x.is_ticket_slab = event;
      });
    },
    checkCinema() {
      if (!this.privateRateCard.cinema_id) {
        this.$toasted.show("Please Select Cinema");
      }
    },
    addRateCard() {
      let obj = {
        is_ticket_slab: "N",
        tt_id: null,
        report_code: "",
        gl_account: "",
        gl_desc: "",
        selectedTicketType: "",
        charge_setting_id: null,
        selected_charge_setting: "",
        is_inclusive_tax: "N",
        price: 0,
        quantity: this.privateRateCard.isPrivateScreening ? 0 : 1,
        net_price: 0,
        total_price: 0,
        tax: [],
        internet_fee: 0,
        total_amount: 0,
        isFnbCompulsory: false,
        fnbCharges: [
          {
            item_id: null,
            item_name: "",
            charge_setting_id: null,
            selected_charge_setting: "",
            is_inclusive_tax: "Y",
            price: 0,
            quantity: 0,
            net_price: 0,
            tax: 0,
            cost_price: 0,
            original_sales_price: 0,
            total_amount: 0,
          },
        ],
      };
      if (this.privateRateCard.isPrivateScreening) {
        obj.is_ticket_slab = this.privateRateCard.ratecards[0].is_ticket_slab;
        obj.tt_id = this.privateRateCard.ratecards[0].tt_id;
        obj.selectedTicketType =
          this.privateRateCard.ratecards[0].selectedTicketType;
      }
      this.privateRateCard.ratecards.push(obj);
    },
    removeRateCard(event, index) {
      if (this.privateRateCard.ratecards[index].rcg_c_id) {
        this.privateRateCard.ratecards[index].rcg_c_is_active = "N";
        if (this.privateRateCard.isPrivateScreening) {
          this.privateRateCard.ratecards[index].rc_is_active = "N";
        }
        this.removedRateCards.push(this.privateRateCard.ratecards[index]);
      }
      this.FnbRateCards.forEach((x) => {
        if (
          String(this.privateRateCard.ratecards[index].quantity) ==
          String(x.quantity)
        ) {
          x.quantity = "";
        }
      });
      this.privateRateCard.ratecards.splice(index, 1);
      let indexOf = -1;
      indexOf = this.FnbQuantityArray.findIndex((x) => x.id == index);
      if (indexOf > -1) {
        this.FnbQuantityArray.splice(indexOf, 1);
      }
      console.log("this.FnbQuantityArray", this.FnbQuantityArray);
    },
    handleQuantityDropDown(quantity, fnbChargeIndex) {
      let count = 0;
      this.FnbRateCards.map((x, i) => {
        if (
          x.item_id == this.FnbRateCards[fnbChargeIndex].item_id &&
          String(x.quantity) == String(quantity.value) &&
          i != fnbChargeIndex
        ) {
          console.log(
            "item_id",
            x.item_id,
            this.FnbRateCards[fnbChargeIndex].item_id
          );
          count++;
          console.log("quantity", x.quantity, quantity.value);
          return this.$toasted.show(
            "This Quantity is Already selected For this Item"
          );
        }
      });
      if (count == 0) {
        this.FnbRateCards[fnbChargeIndex].quantity = parseInt(quantity.value);
      }
    },
    resetHandler(event) {
      console.log("event", event);
      this.privateRateCard.ratecards = [
        {
          is_ticket_slab: "N",
          tt_id: null,
          report_code: "",
          gl_account: "",
          gl_desc: "",
          selectedTicketType: "",
          charge_setting_id: null,
          selected_charge_setting: "",
          price: 0,
          quantity: event ? 0 : 1,
          net_price: 0,
          total_price: 0,
          is_inclusive_tax: "N",
          tax: [],
          internet_fee: 0,
          total_amount: 0,
          isFnbCompulsory: false,
          fnbCharges: [
            {
              item_id: null,
              item_name: "",
              charge_setting_id: null,
              selected_charge_setting: "",
              price: 0,
              quantity: 0,
              net_price: 0,
              is_inclusive_tax: "Y",
              tax: 0,
              cost_price: 0,
              original_sales_price: 0,
              total_amount: 0,
            },
          ],
        },
      ];

      this.FnbRateCards = [
        {
          item_id: null,
          item_name: "",
          charge_setting_id: null,
          selected_charge_setting: "",
          is_inclusive_tax: "Y",
          price: 0,
          quantity: "",
          net_price: 0,
          tax: [],
          cost_price: 0,
          original_sales_price: 0,
          total_amount: 0,
          is_single_fnb: false,
        },
      ];
    },
    addFnbRateCard() {
      let obj = {
        item_id: null,
        item_name: "",
        charge_setting_id: null,
        selected_charge_setting: "",
        is_inclusive_tax: "Y",
        price: 0,
        quantity: "",
        net_price: 0,
        tax: [],
        cost_price: 0,
        original_sales_price: 0,
        total_amount: 0,
        is_single_fnb: false,
      };

      this.FnbRateCards.push(obj);
    },
    removeFnbRateCard(event, index) {
      if (this.FnbRateCards[index].fnb_private_id) {
        this.FnbRateCards[index].is_fnb_rate_card_active = "N";
        this.removedFnbRateCard.push(this.FnbRateCards[index]);
      }
      this.FnbRateCards.splice(index, 1);
    },
    handleRateChange: function (index) {
      if (
        this.isEdit &&
        this.privateRateCard.ratecards[index].hasOwnProperty("rc_id")
      ) {
        this.getCinemaCharges(
          this.privateRateCard.cinema_id,
          this.privateRateCard.ratecards[index].selected_charge_setting,
          index,
          "tt"
        );
      } else {
        this.cinemaChargesCalculation(index);
      }
    },
    handleFNBRateChange: function (index) {
      if (
        this.isEdit &&
        this.FnbRateCards[index].hasOwnProperty("fnb_private_id")
      ) {
        this.getCinemaCharges(
          this.privateRateCard.cinema_id,
          this.FnbRateCards[index].selected_charge_setting,
          index,
          "fnb"
        );
      } else {
        this.FnbChargesCalculation(index);
      }
    },
    onChangeQuantity(event, index) {
      if (this.privateRateCard.isPrivateScreening) {
        let value = event.target.value;
        let count = 0;
        this.privateRateCard.ratecards.map((x, xindex) => {
          if (String(x.quantity) == String(value) && xindex != index) {
            this.privateRateCard.ratecards[index].quantity = 1;
            this.$toasted.show("Quantity Already Exists");
            count++;
          }
        });
        this.FnbRateCards.forEach((x) => {
          let tempVar = this.QuantityArray.findIndex((y) => {
            return String(y.value) == String(x.quantity);
          });
          if (tempVar < 0) {
            x.quantity = "";
          }
        });
      }
    },
    onSearchFnb: function (value) {
      if (this.searchItem && this.searchItem.length > 0) {
        this.fnbItems = this.fnbItemsCopy.filter((x) => {
          if (
            x.item_name.toLowerCase().includes(this.searchItem.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.fnbItems = this.fnbItemsCopy;
      }
    },
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getPrivateRateCardDetails: function (id) {
      let loader = this.$loading.show();
      CinemasService.GetSinglePrivateRatecard({ rcg_id: id })
        .then(async (response) => {
          const { data } = response;
          if (data.status) {
            console.log("response", data);
            this.isEdit = true;

            data.Records[0].ratecards = data.Records[0].ratecards.map(x => {
              let data = { ...x }

              if (
                data.is_inclusive_tax === 'N' &&
                data.hasOwnProperty('__rc_amount') &&
                data.hasOwnProperty('__rc_total_amount') &&
                data.__rc_amount !== data.__rc_total_amount
              ) {
                data.price = data.net_price
                data.total_price = data.__rc_total_amount
              }

              return data
            });

            console.log('\ndata.Records[0].ratecards', window.structuredClone(data.Records[0].ratecards))

            this.privateRateCard = data.Records[0];
            if (
              data.Records &&
              data.Records.length > 0 &&
              data.Records[0].ratecards &&
              data.Records[0].ratecards.length > 0
            ) {
              console.log(
                "data.Records[0].ratecards[0].isFnbCompulsory",
                data.Records[0].ratecards[0].isFnbCompulsory
              );
              this.isFnbCompulsoryForNormalRateCard =
                data.Records[0].ratecards[0].isFnbCompulsory;
            }
            let cine = this.Cinemas.filter(
              (x) => x.cine_id == this.privateRateCard.cinema_id
            );
            this.onSelectCinema(null, cine[0]);
            this.FnbRateCards = data.fnbData;
            this.FnbQuantityArray = data.quantity_array;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          console.log({ error })
          this.$toasted.show(error);
        })
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    getCinemaList: function (cine_id) {
      this.Cinemas = [];
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                let cinema = {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                };

                this.onSelectCinema(null, cinema);
              }
            });

            const { id } = this.$route.query;
            if (id) {
              this.getPrivateRateCardDetails(id);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getChargeSettingName: function (id) {
      this.chargeSettings = [];
      CinemasService.GetCinemaSettingNameByCinemaId({ id })
        .then(async (response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.chargeSettings = data.Records;
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Error :", error);
        });
    },
    getTicketTypeList: function () {
      this.TicketTypes = [];
      let body = {
        tableName: "ms_ticket_type",
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.TicketTypes = data.Records.filter((x) => {
              return x.tt_is_active == "Y";
            });
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch(this._CatchError);
    },
    getFnBItems: function () {
      let body = {
        tableName: "fnb_items",
        item_is_active: "Y",
        rate_card_flag: true,
        with_prices: true,
        with_cost_price: true,
        cinema_id: this.privateRateCard.cinema_id || null,
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.fnbItems = data.Records;
              this.fnbItemsCopy = data.Records;
            }
            // else {
            //   this.$toasted.show(data.message);
            // }
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event, params) {
      this.selectedCinema = params.cine_name;
      this.privateRateCard.cinema_id = params.cine_id;
      this.getFnBItems(params.cine_id);
      this.getChargeSettingName(params.cine_id);
    },
    onSelectTicketType: function (event, tt, index) {
      this.privateRateCard.ratecards[index].selectedTicketType = tt.tt_name;
      this.privateRateCard.ratecards[index].tt_id = tt.tt_id;
      if (this.privateRateCard.isPrivateScreening) {
        this.privateRateCard.ratecards.map((x) => {
          x.tt_id = this.privateRateCard.ratecards[0].tt_id;
          x.selectedTicketType =
            this.privateRateCard.ratecards[0].selectedTicketType;
        });
      }
    },
    onSelectFnbItem: function (event, fnb, index, fnbChargeIndex) {
      this.privateRateCard.ratecards[index].fnbCharges[fnbChargeIndex].item_id =
        fnb.item_id;
      this.privateRateCard.ratecards[index].fnbCharges[
        fnbChargeIndex
      ].item_name = fnb.item_name;
      this.privateRateCard.ratecards[index].fnbCharges[
        fnbChargeIndex
      ].net_price = parseFloat(fnb.fp_amount)
          ? fnb.fp_amount.toFixed(3)
          : "0.00";
      this.privateRateCard.ratecards[index].fnbCharges[fnbChargeIndex].tax =
        parseFloat(fnb.fp_total_amount - fnb.fp_amount).toFixed(3);
      this.privateRateCard.ratecards[index].fnbCharges[
        fnbChargeIndex
      ].original_sales_price = parseFloat(fnb.fp_total_amount).toFixed(3);
      this.privateRateCard.ratecards[index].fnbCharges[
        fnbChargeIndex
      ].cost_price = parseFloat(fnb.itc_cost_price).toFixed(3);
    },
    handleFnbSelect: function (fnb, index) {
      this.FnbRateCards[index].item_id = fnb.item_id;
      this.FnbRateCards[index].item_name = fnb.item_name;
      this.FnbRateCards[index].net_price = 0;
      this.FnbRateCards[index].original_sales_price = parseFloat(
        fnb.fp_total_amount
      ).toFixed(3);
      this.FnbRateCards[index].cost_price = parseFloat(
        fnb.itc_cost_price
      ).toFixed(3);
      this.FnbRateCards[index].price = 0;
    },
    onSelectChargeSetting: function (event, charge, index) {
      this.privateRateCard.ratecards[index].selected_charge_setting =
        charge.pas_charge_setting_name;
      this.privateRateCard.ratecards[index].charge_setting_id = charge.pas_id;
      this.privateRateCard.ratecards[index].price = 0;
      this.privateRateCard.ratecards[index].net_price = 0;
      this.privateRateCard.ratecards[index].total_price = 0;
      this.getCinemaCharges(
        this.privateRateCard.cinema_id,
        charge.pas_charge_setting_name,
        index,
        "tt"
      );
    },
    onSelectticketFnbCharge: function (charge, ticketIndex, fnbIndex) {
      this.privateRateCard.ratecards[ticketIndex].fnbCharges[
        fnbIndex
      ].selected_charge_setting = charge.pas_charge_setting_name;
      this.privateRateCard.ratecards[ticketIndex].fnbCharges[
        fnbIndex
      ].charge_setting_id = charge.pas_id;
    },
    handleFnbCharge: function (charge, fnbIndex) {
      this.FnbRateCards[fnbIndex].charge_setting_id = charge.pas_id;
      this.FnbRateCards[fnbIndex].selected_charge_setting =
        charge.pas_charge_setting_name;
      this.FnbRateCards[fnbIndex].price = 0;
      this.FnbRateCards[fnbIndex].net_price = 0;
      this.getCinemaCharges(
        this.privateRateCard.cinema_id,
        charge.pas_charge_setting_name,
        fnbIndex,
        "fnb"
      );
    },
    checkValidation() {
      let ttErrorCount = 0;
      let csErrorCount = 0;
      let priceErrorCount = 0;
      let quantityErrorCount = 0;
      let netPriceErrorCount = 0;
      let InternetFeeErrorCount = 0;

      let itemErrorCount = 0;
      let fnbCsErrorCount = 0;
      let fnbPriceErrorCount = 0;
      let fnbQuantityErrorCount = 0;
      let fnbNetErrorCount = 0;
      let fnbCostErrorCount = 0;
      let fnbOSPErrorCount = 0;
      let fnbRateCardError = 0;
      let checkDefaultRateCard = [];

      this.privateRateCard.ratecards.map((x) => {
        if (!x.tt_id) {
          ttErrorCount++;
        } else if (!x.charge_setting_id) {
          csErrorCount++;
        } else if (!x.price && x.price != 0) {
          priceErrorCount++;
        } else if (!x.total_price && x.total_price != 0) {
          priceErrorCount++;
        } else if (!x.quantity) {
          quantityErrorCount++;
        } else if (!x.net_price && x.net_price != 0) {
          netPriceErrorCount++;
        } else if (String(x.internet_fee) == "null") {
          InternetFeeErrorCount++;
        }
        console.log("x.isFnbCompulsory", x.isFnbCompulsory);
        if (x.isFnbCompulsory) {
          x.fnbCharges.map((y) => {
            if (!y.item_id) {
              itemErrorCount++;
            } else if (!y.cost_price && y.cost_price != 0) {
              fnbCostErrorCount++;
            } else if (!y.original_sales_price && y.original_sales_price != 0) {
              fnbOSPErrorCount++;
            } else if (!y.net_price && y.net_price != 0) {
              fnbNetErrorCount++;
            }
          });
        }
      });

      checkDefaultRateCard = this.privateRateCard.ratecards.filter(
        (group) => group.default_rate_card == "Y"
      );

      if (this.privateRateCard.isFnbCompulsory) {
        if (this.FnbRateCards.length == 0) {
          fnbRateCardError++;
        }
        this.FnbRateCards.map((y) => {
          if (!y.item_id) {
            itemErrorCount++;
          } else if (!y.charge_setting_id) {
            fnbCsErrorCount++;
          } else if (!y.price && y.price != 0) {
            fnbPriceErrorCount++;
          } else if (
            String(y.quantity) == "null" ||
            String(y.quantity) == "0" ||
            String(y.quantity) == ""
          ) {
            fnbQuantityErrorCount++;
          } else if (!y.cost_price && y.cost_price != 0) {
            fnbCostErrorCount++;
          } else if (!y.original_sales_price && y.original_sales_price != 0) {
            fnbOSPErrorCount++;
          } else if (!y.net_price && y.net_price != 0) {
            fnbNetErrorCount++;
          }
        });
      }

      if (!this.privateRateCard.rate_card_name) {
        this.$toasted.show("Please Enter Rate Card Name");
        return false;
      } else if (ttErrorCount > 0) {
        this.$toasted.show("Please Select Ticket Type");
        return false;
      } else if (csErrorCount > 0) {
        this.$toasted.show("Please Select Charge Setting");
        return false;
      } else if (priceErrorCount > 0) {
        this.$toasted.show("Please Enter Rate per ticket");
        return false;
      } else if (netPriceErrorCount > 0) {
        this.$toasted.show("Please Enter Net Price");
        return false;
      } else if (InternetFeeErrorCount > 0) {
        this.$toasted.show("Please Enter Proper Internet Fee");
        return false;
      } else if (fnbRateCardError > 0) {
        this.$toasted.show("Please Add Fnb Rate Card");
        return false;
      } else if (itemErrorCount > 0) {
        this.$toasted.show("Please Select Fnb Item");
        return false;
      } else if (quantityErrorCount > 0) {
        this.$toasted.show("Please Enter No. of Seats");
        return false;
      } else if (fnbCsErrorCount > 0) {
        this.$toasted.show("Please Select FNB Charge Setting");
        return false;
      } else if (fnbPriceErrorCount > 0) {
        this.$toasted.show("Please Enter FNB Price");
        return false;
      } else if (fnbQuantityErrorCount > 0) {
        this.$toasted.show("Please Enter FNB Quantity");
        return false;
      } else if (fnbCostErrorCount > 0) {
        this.$toasted.show("Please Enter FNB Cost Price");
        return false;
      } else if (fnbOSPErrorCount > 0) {
        this.$toasted.show("Please Enter FNB Original sales Price");
        return false;
      } else if (checkDefaultRateCard.length > 1) {
        this.$toasted.show("Only one default group can be active");
        return false;
      } else if (checkDefaultRateCard.length == 0) {
        this.$toasted.show("Atleast one default group Must be active");
        return false;
      } else {
        return true;
      }
    },
    handleSubmit() {
      this.submitted = true;

      setTimeout(() => {
        if (this.isFnbCompulsoryForNormalRateCard) {
          let fnbCharges = this.privateRateCard.ratecards[0].fnbCharges;
          this.privateRateCard.ratecards.forEach((x) => {
            fnbCharges.map((z) => {
              x["fnbCharges"] = [];
              x["fnbCharges"].push({ ...z });
              x["isFnbCompulsory"] = this.isFnbCompulsoryForNormalRateCard;
            });
          });
        }

        if (this.checkValidation()) {
          let payload = {
            cinema_id: this.cinema_id,
            privateRateCard: this.privateRateCard,
            FnbRateCards: this.FnbRateCards,
            removedRateCards: this.removedRateCards,
            removedFnbRateCard: this.removedFnbRateCard,
          };

          console.log("payload", { ...payload });

          let loader = this.$loading.show();
          CinemasService.AddPrivateRatecard(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.$router.push({
                  path: "/cinema-manager/list-private-rate-card",
                });
                this.submitted = false;
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              this.submitted = false;
              setTimeout(() => loader.hide(), 1000);
            });
        } else {
          console.log("invalid data");
        }
      }, 1000);
    },
    OnSwitchHandler: function (event, item) {
      console.log("event, item :", event, item);
    },
    getCinemaCharges: function (id, charge_setting, index = 0, type = "tt") {
      console.log('getCinemaCharges', { id, charge_setting, index, type })

      console.log('this.privateRateCard.ratecards[index].tax', this.privateRateCard.ratecards[index].tax.length)

      this.cinemaChargesList = [];
      let payload = {
        pas_charge_setting_name: charge_setting,
        id: id,
      };
      CinemasService.GetCinemaChargesByCinemaId(payload)
        .then(async (response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            if (type == "tt") {
              this.cinemaChargesListOnGross = data.Records.filter((z) => {
                return z.pas_is_on_gross_amount == "Y";
              });

              this.cinemaChargeListOnNet = data.Records.filter((z) => {
                return z.pas_is_on_gross_amount == "N";
              });
              this.cinemaChargesListCopy = data.Records;
              // this.privateRateCard.ratecards[index].tax = [];
              if (
                !this.privateRateCard.ratecards[index].hasOwnProperty("rc_id")
              ) {
                this.privateRateCard.ratecards[index].tax = [];
              }

              console.log('this.cinemaChargesListOnGross.length == 0', this.cinemaChargesListOnGross.length == 0)

              if (this.cinemaChargesListOnGross.length == 0) {
                this.cinemaChargesListOnGross = [...this.cinemaChargeListOnNet];
                this.cinemaChargeListOnNet = [];
              }

              let temp_array = [...this.privateRateCard.ratecards[index].tax];

              console.log('cinemaChargesListOnGross', this.cinemaChargesListOnGross.length)
              console.log('cinemaChargeListOnNet', this.cinemaChargeListOnNet.length)
              console.log('temp_array', temp_array)

              // On Net
              if (this.cinemaChargeListOnNet.length) {
                let promisesOnNet = this.cinemaChargeListOnNet.map((x) => {
                  x["cinemacharges"] = 0;
                  let obj = {
                    charge_name: x.ct_name,
                    cinemacharges: x.cinemacharges,
                    charge_value: x.pas_charge_value,
                    ct_id: x.ct_id,
                    pas_id: x.pas_id,
                    pas_is_percentage: x.pas_is_percentage,
                  };
                  return obj;
                });

                console.log('promisesOnNet', promisesOnNet)

                if (
                  this.isEdit &&
                  this.privateRateCard.ratecards[index].hasOwnProperty("rc_id")
                ) {
                  promisesOnNet.map((x) => {
                    let temp = temp_array.filter((y) => y.ct_id == x.ct_id);

                    if (temp.length > 0) {
                      x["rcs_id"] = temp[0]["rcs_id"];
                    }
                  });
                  this.privateRateCard.ratecards[index].tax = [
                    ...promisesOnNet,
                  ];
                } else {
                  this.privateRateCard.ratecards[index].tax = [
                    ...promisesOnNet,
                  ];
                }
              }
              // On Gross
              if (this.cinemaChargesListOnGross.length > 0) {
                let promisesOnGross = this.cinemaChargesListOnGross.map((x) => {
                  x["cinemacharges"] = 0;
                  let obj = {
                    charge_name: x.ct_name,
                    cinemacharges: x.cinemacharges,
                    charge_value: x.pas_charge_value,
                    ct_id: x.ct_id,
                    pas_id: x.pas_id,
                    pas_is_percentage: x.pas_is_percentage,
                  };
                  return obj;
                });

                console.log('promisesOnGross', promisesOnGross)

                if (
                  this.isEdit &&
                  this.privateRateCard.ratecards[index].hasOwnProperty("rc_id")
                ) {
                  promisesOnGross.map((x) => {
                    let temp = temp_array.filter((y) => y.ct_id == x.ct_id);

                    console.log({
                      'x.ct_id': x.ct_id,
                      temp,
                      'x["rcs_id"]': x["rcs_id"],
                      'temp[0]["rcs_id"]': temp.length ? temp[0]["rcs_id"] : ''
                    })

                    if (temp.length > 0) {
                      x["rcs_id"] = temp[0]["rcs_id"];
                    }
                  });
                  console.log('this.privateRateCard.ratecards[index].tax', this.privateRateCard.ratecards[index].tax.length)

                  this.privateRateCard.ratecards[index].tax = [
                    // ...this.privateRateCard.ratecards[index].tax,
                    ...promisesOnGross,
                  ];

                  console.log('this.privateRateCard.ratecards[index].tax', this.privateRateCard.ratecards[index].tax.length)

                  this.cinemaChargesCalculation(index);
                } else {
                  this.privateRateCard.ratecards[index].tax = [
                    // ...this.privateRateCard.ratecards[index].tax,
                    ...promisesOnGross,
                  ];
                }
              }
            } else if (type == "fnb") {
              this.fnbtaxChargesList = data.Records;
              this.fnbtaxChargesListCopy = data.Records;
              if (!this.FnbRateCards[index].hasOwnProperty("fnb_private_id")) {
                this.FnbRateCards[index].tax = [];
              }
              let promises = this.fnbtaxChargesList.map((x) => {
                x["cinemacharges"] = 0;
                let obj = {
                  charge_name: x.ct_name,
                  cinemacharges: x.cinemacharges,
                  charge_value: x.pas_charge_value,
                  ct_id: x.ct_id,
                  pas_id: x.pas_id,
                  pas_is_percentage: x.pas_is_percentage,
                };
                return obj;
              });
              if (
                this.isEdit &&
                this.FnbRateCards[index].hasOwnProperty("fnb_private_id")
              ) {
                promises.map((x) => {
                  let temp = this.FnbRateCards[index].tax.filter(
                    (y) => y.ct_id == x.ct_id
                  );
                  if (temp.length > 0) {
                    x["rcs_id"] = temp[0]["rcs_id"];
                  }
                });
                this.FnbRateCards[index].tax = promises;
                this.FnbChargesCalculation(index);
              } else {
                this.FnbRateCards[index].tax = promises;
              }
            }
            // await Promise.all(promises).then(() => {
            //   this.cinemaChargesCalculation(index);
            // });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },

    cinemaChargesCalculationONNetNew: function (rateCardIndex) {
      console.log(this.cinemaChargeListOnNet, "cinemaChargesList");
      if (
        String(this.privateRateCard.ratecards[rateCardIndex].net_price).length >
        0
      ) {
        this.privateRateCard.ratecards[rateCardIndex]["on_gross"] =
          this.privateRateCard.ratecards[rateCardIndex].net_price;
        //Setup the initial value of net and total
        this.privateRateCard.ratecards[rateCardIndex].net_price = parseFloat(
          this.privateRateCard.ratecards[rateCardIndex].net_price
        );
        if (
          this.privateRateCard.ratecards[rateCardIndex].is_inclusive_tax == "N"
        ) {
          //if percentage, create the cinema charge on top of the initial ratecard input
          this.cinemaChargeListOnNet.map((x, index) => {
            if (x.pas_is_percentage === "Y") {
              x.cinemacharges = parseFloat(
                (parseFloat(
                  this.privateRateCard.ratecards[rateCardIndex].price
                ) *
                  parseFloat(x.pas_charge_value)) /
                100
              ).toFixed(3);
            }
            this.privateRateCard.ratecards[rateCardIndex].tax[
              index
            ].cinemacharges = x.cinemacharges;
            //create the sum assuming total is excluding taxes
            if (x.pas_is_rebate == "N") {
              x.extraChargesSum = parseFloat(
                parseFloat(x.extraChargesSum) + parseFloat(x.cinemacharges)
              ).toFixed(3);
            } else {
              x.extraChargesSum = parseFloat(
                parseFloat(x.extraChargesSum) - parseFloat(x.cinemacharges)
              ).toFixed(3);
            }
            x.extraChargesSum = parseFloat(
              parseFloat(x.extraChargesSum) + parseFloat(x.cinemacharges)
            ).toFixed(3);

            //add the cinema charge to the net amount to create total
            this.calculateNetAmount(x, "Plus", rateCardIndex);
          });
        } else if (
          this.privateRateCard.ratecards[rateCardIndex].is_inclusive_tax == "Y"
        ) {
          var t = this.privateRateCard.ratecards[rateCardIndex].net_price,
            grossAmount =
              this.privateRateCard.ratecards[rateCardIndex].net_price;
          var k = 0,
            sumFixedTaxable = 0,
            w = 0,
            sumFixedRebate = 0,
            v = 0,
            sumFixedTax = 0,
            y = 0,
            sumPercentageTaxable = 0,
            z = 0,
            sumPercentageRebate = 0,
            a = 0,
            sumPercentageTax = 0;

          this.cinemaChargeListOnNet.map((x, index) => {
            if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              k += x.pas_charge_value;
            } else if (x.pas_is_percentage === "N" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              w += x.pas_charge_value;
            } else if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              v += x.pas_charge_value;
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              y += x.pas_charge_value;
            } else if (x.pas_is_percentage === "Y" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              z += x.pas_charge_value;
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              a += x.pas_charge_value;
            }
          });
          sumFixedTaxable = k;
          sumFixedRebate = w;
          sumFixedTax = v;
          sumPercentageTaxable = y;
          sumPercentageRebate = z;
          sumPercentageTax = a;
          this.totalTaxPercentage = sumPercentageTax;

          // this.privateRateCard.ratecards[rateCardIndex].net_price = parseFloat(
          //   (10000 * t +
          //     10000 * w -
          //     10000 * v +
          //     100 * k * z -
          //     100 * k * a -
          //     10000 * k) /
          //     (10000 + y * a - z * y + 100 * y + 100 * a - 100 * z)
          // ).toFixed(3);
          w = 0;
          z = 0;

          // console.log(netAmount)
          console.log(
            "1 this.ratecard.rc_net_amount",
            this.privateRateCard.ratecards[rateCardIndex].net_price
          );

          let total_tax_amount = 0;

          this.cinemaChargeListOnNet.map((x, index2) => {
            let index = this.privateRateCard.ratecards[rateCardIndex][
              "tax"
            ].findIndex((zz) => {
              return zz.ct_id == x.charge_type_id;
            });
            if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(3);
            } else if (x.pas_is_percentage === "N" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(3);
            } else if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(3);
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              x.cinemacharges = parseFloat(
                (x.pas_charge_value *
                  this.privateRateCard.ratecards[rateCardIndex].net_price) /
                100
              ).toFixed(3);
            } else if (x.pas_is_percentage === "Y" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              x.cinemacharges = parseFloat(
                (x.pas_charge_value *
                  this.privateRateCard.ratecards[rateCardIndex].net_price) /
                100
              ).toFixed(3);
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              x.cinemacharges = parseFloat(
                (x.pas_charge_value *
                  this.privateRateCard.ratecards[rateCardIndex].net_price) /
                100
              ).toFixed(3);
            }
            this.privateRateCard.ratecards[rateCardIndex].tax[
              index
            ].cinemacharges = x.cinemacharges;
            total_tax_amount += +parseFloat(x.cinemacharges);
          });
          this.privateRateCard.ratecards[rateCardIndex].net_price = +parseFloat(
            this.privateRateCard.ratecards[rateCardIndex].net_price -
            total_tax_amount
          ).toFixed(3);
        }
      }
    },
    cinemaChargesCalculation: function (rateCardIndex) {
      console.log();

      console.log(window.structuredClone(this.cinemaChargeListOnNet), "cinemaChargeListOnNet");
      console.log(window.structuredClone(this.cinemaChargesListOnGross), "cinemaChargesListOnGross");

      if (
        String(this.privateRateCard.ratecards[rateCardIndex].price).length > 0
      ) {
        //Setup the initial value of net and total
        this.privateRateCard.ratecards[rateCardIndex].net_price = parseFloat(
          this.privateRateCard.ratecards[rateCardIndex].price
        );
        this.privateRateCard.ratecards[rateCardIndex].total_price = parseFloat(
          this.privateRateCard.ratecards[rateCardIndex].price
        );

        console.log('net_price', this.privateRateCard.ratecards[rateCardIndex].net_price)
        console.log('total_price', this.privateRateCard.ratecards[rateCardIndex].total_price)

        if (
          this.privateRateCard.ratecards[rateCardIndex].is_inclusive_tax == "N"
        ) {
          //if percentage, create the cinema charge on top of the initial ratecard input
          this.cinemaChargesListOnGross.map((x, index) => {
            if (x.pas_is_percentage === "Y") {
              x.cinemacharges = parseFloat(
                (parseFloat(
                  this.privateRateCard.ratecards[rateCardIndex].price
                ) *
                  parseFloat(x.pas_charge_value)) /
                100
              ).toFixed(3);
            }
            this.privateRateCard.ratecards[rateCardIndex].tax[
              index
            ].cinemacharges = x.cinemacharges;
            //create the sum assuming total is excluding taxes
            if (x.pas_is_rebate == "N") {
              x.extraChargesSum = parseFloat(
                parseFloat(x.extraChargesSum) + parseFloat(x.cinemacharges)
              ).toFixed(3);
            } else {
              x.extraChargesSum = parseFloat(
                parseFloat(x.extraChargesSum) - parseFloat(x.cinemacharges)
              ).toFixed(3);
            }
            x.extraChargesSum = parseFloat(
              parseFloat(x.extraChargesSum) + parseFloat(x.cinemacharges)
            ).toFixed(3);

            //add the cinema charge to the net amount to create total
            this.calculateNetAmount(x, "Plus", rateCardIndex);
          });
        } else if (
          this.privateRateCard.ratecards[rateCardIndex].is_inclusive_tax == "Y"
        ) {
          var t = this.privateRateCard.ratecards[rateCardIndex].price,
            grossAmount = this.privateRateCard.ratecards[rateCardIndex].price;
          var k = 0,
            sumFixedTaxable = 0,
            w = 0,
            sumFixedRebate = 0,
            v = 0,
            sumFixedTax = 0,
            y = 0,
            sumPercentageTaxable = 0,
            z = 0,
            sumPercentageRebate = 0,
            a = 0,
            sumPercentageTax = 0;

          this.cinemaChargesListOnGross.map((x, index) => {
            if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              k += x.pas_charge_value;
            } else if (x.pas_is_percentage === "N" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              w += x.pas_charge_value;
            } else if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              v += x.pas_charge_value;
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              y += x.pas_charge_value;
            } else if (x.pas_is_percentage === "Y" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              z += x.pas_charge_value;
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              a += x.pas_charge_value;
            }
          });
          sumFixedTaxable = k;
          sumFixedRebate = w;
          sumFixedTax = v;
          sumPercentageTaxable = y;
          sumPercentageRebate = z;
          sumPercentageTax = a;
          this.totalTaxPercentage = sumPercentageTax;

          this.privateRateCard.ratecards[rateCardIndex].net_price = parseFloat(
            (10000 * t +
              10000 * w -
              10000 * v +
              100 * k * z -
              100 * k * a -
              10000 * k) /
            (10000 + y * a - z * y + 100 * y + 100 * a - 100 * z)
          ).toFixed(3);
          w = 0;
          z = 0;

          // console.log(netAmount)
          console.log(
            "1 this.ratecard.rc_net_amount",
            this.privateRateCard.ratecards[rateCardIndex].net_price
          );

          this.cinemaChargesListOnGross.map((x, index2) => {
            let index = this.privateRateCard.ratecards[rateCardIndex][
              "tax"
            ].findIndex((zz) => {
              return zz.ct_id == x.charge_type_id;
            });
            if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(3);
            } else if (x.pas_is_percentage === "N" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(3);
            } else if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(3);
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              x.cinemacharges = parseFloat(
                (x.pas_charge_value *
                  this.privateRateCard.ratecards[rateCardIndex].net_price) /
                100
              ).toFixed(3);
            } else if (x.pas_is_percentage === "Y" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              x.cinemacharges = parseFloat(
                (x.pas_charge_value *
                  this.privateRateCard.ratecards[rateCardIndex].net_price) /
                100
              ).toFixed(3);
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              x.cinemacharges = parseFloat(
                (x.pas_charge_value *
                  this.privateRateCard.ratecards[rateCardIndex].net_price) /
                100
              ).toFixed(3);
            }
            this.privateRateCard.ratecards[rateCardIndex].tax[
              index
            ].cinemacharges = x.cinemacharges;
          });
        }
      }

      if (this.cinemaChargeListOnNet.length > 0) {
        this.cinemaChargesCalculationONNetNew(rateCardIndex);
      }

      console.log(window.structuredClone(this.cinemaChargeListOnNet), "cinemaChargeListOnNet");
      console.log(window.structuredClone(this.cinemaChargesListOnGross), "cinemaChargesListOnGross");
      console.log();
    },
    FnbChargesCalculation: function (fnbIndex) {
      if (String(this.FnbRateCards[fnbIndex].price).length > 0) {
        //Setup the initial value of net and total
        this.FnbRateCards[fnbIndex].net_price = parseFloat(
          this.FnbRateCards[fnbIndex].price
        );
        if (this.FnbRateCards[fnbIndex].is_inclusive_tax == "N") {
          //if percentage, create the cinema charge on top of the initial ratecard input
          this.fnbtaxChargesList.map((x, index) => {
            if (x.pas_is_percentage === "Y") {
              x.cinemacharges = parseFloat(
                (parseFloat(this.FnbRateCards[fnbIndex].price) *
                  parseFloat(x.pas_charge_value)) /
                100
              ).toFixed(3);
            }
            this.FnbRateCards[fnbIndex].tax[index].cinemacharges =
              x.cinemacharges;
            //create the sum assuming total is excluding taxes
            if (x.pas_is_rebate == "N") {
              x.extraChargesSum = parseFloat(
                parseFloat(x.extraChargesSum) + parseFloat(x.cinemacharges)
              ).toFixed(3);
            } else {
              x.extraChargesSum = parseFloat(
                parseFloat(x.extraChargesSum) - parseFloat(x.cinemacharges)
              ).toFixed(3);
            }
            x.extraChargesSum = parseFloat(
              parseFloat(x.extraChargesSum) + parseFloat(x.cinemacharges)
            ).toFixed(3);
          });
        } else if (this.FnbRateCards[fnbIndex].is_inclusive_tax == "Y") {
          var t = this.FnbRateCards[fnbIndex].price,
            grossAmount = this.FnbRateCards[fnbIndex].price;
          var k = 0,
            sumFixedTaxable = 0,
            w = 0,
            sumFixedRebate = 0,
            v = 0,
            sumFixedTax = 0,
            y = 0,
            sumPercentageTaxable = 0,
            z = 0,
            sumPercentageRebate = 0,
            a = 0,
            sumPercentageTax = 0;

          this.fnbtaxChargesList.map((x, index) => {
            if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              k += x.pas_charge_value;
            } else if (x.pas_is_percentage === "N" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              w += x.pas_charge_value;
            } else if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              v += x.pas_charge_value;
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              y += x.pas_charge_value;
            } else if (x.pas_is_percentage === "Y" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              z += x.pas_charge_value;
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              a += x.pas_charge_value;
            }
          });
          sumFixedTaxable = k;
          sumFixedRebate = w;
          sumFixedTax = v;
          sumPercentageTaxable = y;
          sumPercentageRebate = z;
          sumPercentageTax = a;
          this.totalFnbTaxPercentage = sumPercentageTax;

          this.FnbRateCards[fnbIndex].net_price = parseFloat(
            (10000 * t +
              10000 * w -
              10000 * v +
              100 * k * z -
              100 * k * a -
              10000 * k) /
            (10000 + y * a - z * y + 100 * y + 100 * a - 100 * z)
          ).toFixed(3);
          w = 0;
          z = 0;

          // console.log(netAmount)
          console.log(
            "1 this.ratecard.rc_net_amount",
            this.FnbRateCards[fnbIndex].net_price
          );

          this.fnbtaxChargesList.map((x, index) => {
            if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(3);
            } else if (x.pas_is_percentage === "N" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(3);
            } else if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(3);
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              x.cinemacharges = parseFloat(
                (x.pas_charge_value * this.FnbRateCards[fnbIndex].net_price) /
                100
              ).toFixed(3);
            } else if (x.pas_is_percentage === "Y" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              x.cinemacharges = parseFloat(
                (x.pas_charge_value * this.FnbRateCards[fnbIndex].net_price) /
                100
              ).toFixed(3);
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              x.cinemacharges = parseFloat(
                (x.pas_charge_value * this.FnbRateCards[fnbIndex].net_price) /
                100
              ).toFixed(3);
            }
            this.FnbRateCards[fnbIndex].tax[index].cinemacharges =
              x.cinemacharges;
          });
        }
      }
    },
    calculateNetAmount: function (x, equation, rateCardIndex) {
      if (equation === "Plus") {
        if (x.pas_is_percentage === "Y" && x.pas_is_rebate === "N") {
          this.privateRateCard.ratecards[rateCardIndex].total_price += parseFloat(x.cinemacharges);
        } else if (x.pas_is_percentage === "Y" && x.pas_is_rebate === "Y") {
          this.privateRateCard.ratecards[rateCardIndex].total_price =
            this.privateRateCard.ratecards[rateCardIndex].total_price - parseFloat(x.cinemacharges);
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "N" &&
          x.pas_is_rebate == "N"
        ) {
          this.privateRateCard.ratecards[rateCardIndex].total_price += parseFloat(x.pas_charge_value);
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "N" &&
          x.pas_is_rebate == "Y"
        ) {
          this.privateRateCard.ratecards[rateCardIndex].total_price =
            this.privateRateCard.ratecards[rateCardIndex].total_price - parseFloat(x.pas_charge_value);
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "Y" &&
          x.pas_is_rebate == "N"
        ) {
          this.privateRateCard.ratecards[rateCardIndex].total_price += parseFloat(x.pas_charge_value);
        }
      }
      //
      else if (equation === "Minus") {
        if (x.pas_is_percentage === "Y" && x.pas_is_rebate == "N") {
          console.log("if :", x.cinemacharges);
          this.ratecard.rc_net_amount -= parseFloat(x.cinemacharges);
        } else if (x.pas_is_percentage === "Y" && x.pas_is_rebate == "Y") {
          this.ratecard.rc_net_amount =
            this.ratecard.rc_net_amount + parseFloat(x.cinemacharges);
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "N" &&
          x.pas_is_overnabove === "N" &&
          x.pas_is_rebate === "N"
        ) {
          this.ratecard.rc_net_amount -= parseFloat(x.pas_charge_value);
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "Y" &&
          x.pas_is_rebate === "N"
        ) {
          console.log("test3", x.pas_charge_value);
          this.ratecard.rc_net_amount -= parseFloat(x.pas_charge_value);
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "N" &&
          x.pas_is_overnabove === "N" &&
          x.pas_is_rebate === "Y"
        ) {
          this.ratecard.rc_net_amount =
            this.ratecard.rc_net_amount + parseFloat(x.pas_charge_value);
        }
      }

    },
    getCurrencyCode: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>

<style>
.pvt-rate-card {
  background-color: white;
  /* padding: 32px 0; */
}

.pvt-rate-card h2,
.pvt-rate-card h3 {
  font-weight: bold;
  color: var(--blue);
}

.pvt-rate-card-box p {
  margin: 0;
}

.pvt-rate-card .pvt-rate-card-box {
  background-color: #e6e6f8;
  /* box-shadow: 0 0 15px rgba(32, 21, 21, 0.5); */
  border-radius: 1rem;
  padding: 16px;
  /* margin-top: 16px; */
  border: 2px solid var(--blue);
  line-height: 1.2;
}

.pvt-rate-card-box>section {
  display: grid;
  grid-template-columns: repeat(4, 23%);
  grid-gap: 8px 2%;
  width: 100%;
}

.pvt-rate-card-box>section>article p:first-child {
  color: var(--blue);
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 4px;
}

.pvt-rate-card-box>section>article .movie-dropdown {
  width: 100%;
}

.overFlow-ellipisis button {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.pvt-rate-card-box .total-price {
  color: var(--blue);
  font-weight: bold;
  text-align: right;
  font-size: 23px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
}

.no-border {
  border: none !important;
}

.border-top-dark {
  border-top: 1px solid black !important;
}

.pvt-rate-card-box .form-control {
  border-radius: 10px !important;
  min-height: 40px !important;
}

.section-collapse-box {
  border: 1px solid var(--lightgrey);
  border-radius: 10px;
  padding: 10px;
}

.qtdisable {
  background-color: #f3f3f3;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/RatecardComponents/privateRateCardExclusiveTax.vue